export default [
  {"ph":7,"nm":350,"abs":0.432},
  {"ph":7,"nm":355,"abs":0.432},
  {"ph":7,"nm":360,"abs":0.432},
  {"ph":7,"nm":365,"abs":0.432},
  {"ph":7,"nm":370,"abs":0.432},
  {"ph":7,"nm":375,"abs":0.432},
  {"ph":7,"nm":380,"abs":0.432},
  {"ph":7,"nm":385,"abs":0.432},
  {"ph":7,"nm":390,"abs":0.432},
  {"ph":7,"nm":395,"abs":0.432},
  {"ph":7,"nm":400,"abs":0.432},
  {"ph":7,"nm":405,"abs":0.432},
  {"ph":7,"nm":410,"abs":0.432},
  {"ph":7,"nm":415,"abs":0.432},
  {"ph":7,"nm":420,"abs":0.432},
  {"ph":7,"nm":425,"abs":0.432},
  {"ph":7,"nm":430,"abs":0.432},
  {"ph":7,"nm":435,"abs":0.432},
  {"ph":7,"nm":440,"abs":0.432},
  {"ph":7,"nm":445,"abs":0.432},
  {"ph":7,"nm":450,"abs":0.432},
  {"ph":7,"nm":455,"abs":0.432},
  {"ph":7,"nm":460,"abs":0.432},
  {"ph":7,"nm":465,"abs":0.432},
  {"ph":7,"nm":470,"abs":0.432},
  {"ph":7,"nm":475,"abs":0.432},
  {"ph":7,"nm":480,"abs":0.432},
  {"ph":7,"nm":485,"abs":0.432},
  {"ph":7,"nm":490,"abs":0.432},
  {"ph":7,"nm":495,"abs":0.432},
  {"ph":7,"nm":500,"abs":0.432},
  {"ph":7,"nm":505,"abs":0.432},
  {"ph":7,"nm":510,"abs":0.432},
  {"ph":7,"nm":515,"abs":0.432},
  {"ph":7,"nm":520,"abs":0.432},
  {"ph":7,"nm":525,"abs":0.432},
  {"ph":7,"nm":530,"abs":0.432},
  {"ph":7,"nm":535,"abs":0.432},
  {"ph":7,"nm":540,"abs":0.432},
  {"ph":7,"nm":545,"abs":0.432},
  {"ph":7,"nm":550,"abs":0.432},
  {"ph":7,"nm":555,"abs":0.432},
  {"ph":7,"nm":560,"abs":0.432},
  {"ph":7,"nm":565,"abs":0.432},
  {"ph":7,"nm":570,"abs":0.432},
  {"ph":7,"nm":575,"abs":0.432},
  {"ph":7,"nm":580,"abs":0.432},
  {"ph":7,"nm":585,"abs":0.432},
  {"ph":7,"nm":590,"abs":0.432},
  {"ph":7,"nm":595,"abs":0.432},
  {"ph":7,"nm":600,"abs":0.432},
  {"ph":7,"nm":605,"abs":0.432},
  {"ph":7,"nm":610,"abs":0.432},
  {"ph":7,"nm":615,"abs":0.432},
  {"ph":7,"nm":620,"abs":0.432},
  {"ph":7,"nm":625,"abs":0.432},
  {"ph":7,"nm":630,"abs":0.432},
  {"ph":7,"nm":635,"abs":0.432},
  {"ph":7,"nm":640,"abs":0.432},
  {"ph":7,"nm":645,"abs":0.432},
  {"ph":7,"nm":650,"abs":0.432},
  {"ph":7,"nm":655,"abs":0.432},
  {"ph":7,"nm":660,"abs":0.432},
  {"ph":7,"nm":665,"abs":0.432},
  {"ph":7,"nm":670,"abs":0.432},
  {"ph":7,"nm":675,"abs":0.432},
  {"ph":7,"nm":680,"abs":0.432},
  {"ph":7,"nm":685,"abs":0.432},
  {"ph":7,"nm":690,"abs":0.432},
  {"ph":7,"nm":695,"abs":0.432},
  {"ph":7,"nm":700,"abs":0.432},
  {"ph":7,"nm":705,"abs":0.432},
  {"ph":7,"nm":710,"abs":0.432},
  {"ph":7,"nm":715,"abs":0.432},
  {"ph":7,"nm":720,"abs":0.432},
  {"ph":7,"nm":725,"abs":0.432},
  {"ph":7,"nm":730,"abs":0.432},
  {"ph":7,"nm":735,"abs":0.432},
  {"ph":7,"nm":740,"abs":0.432},
  {"ph":7,"nm":745,"abs":0.432},
  {"ph":7,"nm":750,"abs":0.432}
]
